import { SVGProps, Ref, forwardRef } from 'react';

export const ChartLineFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5m4.987 5.832-.99-.99-3.332 3.332-2.333-2.333-3.323 3.323.99.99 2.333-2.333 2.333 2.333z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ChartLineFilledSize16Glyph.displayName = 'ChartLineFilledSize16Glyph';
